import React from "react";
import { LegalPage, LegalBlock } from "@/components/site/LegalPage";
import { openCookieSettings } from "@/components/site/CookieConsent";

export default function Confidentialite() {
  return (
    <LegalPage
      title="Politique de confidentialité"
      path="/politique-confidentialite"
    >
      <LegalBlock heading="Données collectées">
        <p>
          Ce site vitrine ne collecte pas de données personnelles via un
          formulaire. Les prises de rendez-vous sont effectuées directement sur
          la plateforme Planity, qui dispose de sa propre politique de
          confidentialité.
        </p>
      </LegalBlock>

      <LegalBlock heading="Cookies">
        <p>
          Seuls des cookies strictement nécessaires au bon fonctionnement du
          site sont utilisés. Aucun traceur publicitaire ou de mesure
          d’audience non essentiel n’est déposé sans votre consentement.
        </p>
        <p>
          Vous pouvez à tout moment modifier votre choix :{" "}
          <button
            type="button"
            data-testid="confidentialite-cookie-settings"
            onClick={openCookieSettings}
            className="underline text-[#904234] hover:text-[#4b2018] transition-colors"
          >
            gérer les cookies
          </button>
          .
        </p>
      </LegalBlock>

      <LegalBlock heading="Vos droits">
        <p>
          Conformément au RGPD, vous disposez d’un droit d’accès, de
          rectification et de suppression de vos données. Pour toute demande,
          vous pouvez nous contacter : ninaa.beaauty@gmail.com.
        </p>
      </LegalBlock>

      <LegalBlock heading="Responsable du traitement">
        <p>
          Ninaa Beauty — 31 rue du Rempart Matabiau, 31000 Toulouse
        </p>
      </LegalBlock>
    </LegalPage>
  );
}
